module.exports = "/_next/static/files/c1e9a1a42a038398fa83fccebfda6c23.svg";